import { FC } from 'react';
import { Paper, Text } from '@mantine/core';
import styles from '@/PageComponents/Onboarding/components/SetupProgress.module.css';

const SetupProgress: FC<{ completed: number; total: number }> = ({ completed, total }) => (
    <Paper radius={4} className={styles.card}>
        {/* Phones put the count beside the label. */}
        <div className={styles.heading}>
            <Text className={styles.label}>{completed >= total ? 'Stage one complete' : 'Stage one progress'}</Text>
            <Text className={`${styles.count} ${completed > 0 ? styles.countStarted : ''}`} data-testid="onboarding-progress-count">{completed}/{total}</Text>
        </div>
        <div className={styles.segments} aria-hidden="true">
            {Array.from({ length: total }, (_, i) => (
                <div key={i} className={`${styles.segment} ${i < completed ? styles.done : ''}`} />
            ))}
        </div>
    </Paper>
);

export default SetupProgress;
